/* eco-trade PDP extras: accessory total, volume price table, palette dialogs */
(() => {
  const fmt = (cents, format) => {
    if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, format || theme.settings.moneyFormat);
    return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  };
  const onVariant = (sectionId, cb) => {
    if (window.theme && theme.pubsub) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange, (e) => {
        const d = e && e.data ? e.data : e;
        if (d && d.variant && (!d.sectionId || d.sectionId === sectionId)) cb(d.variant);
      });
    }
    document.addEventListener('variant:change', (e) => { if (e.detail && e.detail.variant) cb(e.detail.variant); });
  };

  class ProductZubehoer extends HTMLElement {
    connectedCallback() {
      this.base = parseInt(this.dataset.basePrice || '0', 10);
      this.totalWrap = this.querySelector('.product__zubehoer-total');
      this.totalEl = this.querySelector('[data-total]');
      this.addEventListener('change', () => this.update());
      onVariant(this.dataset.sectionId, (v) => { this.base = v.price; this.update(); });
      this.update();
    }
    update() {
      const checked = Array.from(this.querySelectorAll('input[name="bundles"]:checked'));
      const extra = checked.reduce((s, i) => s + parseInt(i.dataset.price || '0', 10), 0);
      if (this.totalWrap) this.totalWrap.hidden = checked.length === 0;
      if (this.totalEl) this.totalEl.textContent = fmt(this.base + extra, this.dataset.moneyFormat);
    }
  }
  if (!customElements.get('product-zubehoer')) customElements.define('product-zubehoer', ProductZubehoer);

  class ProductMengenpreis extends HTMLElement {
    connectedCallback() {
      onVariant(this.dataset.sectionId, (v) => this.render(v.price));
    }
    render(price) {
      this.querySelectorAll('[data-tier]').forEach((td) => {
        const pct = parseFloat(td.dataset.tier || '0');
        const val = Math.round(price * (100 - pct) / 100);
        const suffix = td.querySelector('span');
        td.textContent = fmt(val, this.dataset.moneyFormat) + ' ';
        if (suffix) td.appendChild(suffix);
      });
    }
  }
  if (!customElements.get('product-mengenpreis')) customElements.define('product-mengenpreis', ProductMengenpreis);

  document.addEventListener('click', (e) => {
    const open = e.target.closest('[data-palette-open]');
    if (open) { const d = document.getElementById(open.dataset.paletteOpen); if (d && d.showModal) d.showModal(); return; }
    const more = e.target.closest('[data-zubehoer-more]');
    if (more) {
      const wrap = more.closest('product-zubehoer');
      const extras = wrap.querySelectorAll('.zubehoer-card.is-extra');
      const opening = extras.length && extras[0].hidden;
      extras.forEach((el) => { el.hidden = !opening; });
      if (!more.dataset.labelMore) more.dataset.labelMore = more.textContent;
      more.textContent = opening ? more.dataset.labelLess : more.dataset.labelMore;
      return;
    }
    const close = e.target.closest('[data-palette-close]');
    if (close) { close.closest('dialog')?.close(); return; }
    if (e.target.matches('dialog.palette-dialog')) e.target.close(); // click on backdrop
  });
})();
